'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _types = require('./types');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (state, _ref) {
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _types.INIT:
    case _types.RESET:
      {
        var environment = payload.environment || 'development';

        return _extends({}, state, {
          product: payload.product,
          profile: payload.profile || {},
          loggedIn: payload.loggedIn || false,
          config: _extends({}, state.config, payload.config || {}),
          menus: payload.menus || [],
          notification: _extends({}, state.notification, payload.notification || {}),
          brand: _extends({}, state.brand, payload.brand || {}),
          login: _extends({}, state.login, payload.login || {}),
          logout: _extends({}, state.logout, payload.logout || {}),
          signUp: _extends({}, state.signUp, payload.signUp || {}),
          environment: environment,
          metric: payload.metric || state.metric,
          heimdall: _extends({}, state.heimdall, state.heimdall.environments[environment])
        });
      }
    case _types.PRODUCT:
      {
        return _extends({}, state, {
          product: payload
        });
      }
    case _types.GRADIENT:
      {
        return _extends({}, state, {
          config: _extends({}, state.config, {
            gradient: payload.gradient,
            gradientColor: payload.gradientColor || state.config.gradientColor
          })
        });
      }
    case _types.CONFIG:
      {
        return _extends({}, state, {
          config: _extends({}, state.config, payload)
        });
      }
    case _types.SIGNUP:
      {
        return _extends({}, state, {
          signUp: _extends({}, state.signUp, payload)
        });
      }
    case _types.MENUS:
      {
        return _extends({}, state, {
          menus: payload
        });
      }
    case _types.NOTIFICATION:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            active: payload
          })
        });
      }
    case _types.NOTIFICATIONS_UNREAD:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            unread: payload,
            loading: false,
            unreadLoaded: true
          })
        });
      }
    case _types.NOTIFICATIONS_READ:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            loading: false,
            list: payload
          })
        });
      }
    case _types.NOTIFICATIONS_SUCCESS:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            loading: false,
            list: state.notification.list.length > 0 ? state.notification.list.concat(payload) : payload
          })
        });
      }
    case _types.NOTIFICATIONS_ERROR:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            loading: false
          })
        });
      }
    case _types.NOTIFICATIONS_LOADING:
      {
        return _extends({}, state, {
          notification: _extends({}, state.notification, {
            loading: payload
          })
        });
      }
    case _types.LOGGED:
      {
        return _extends({}, state, {
          loggedIn: payload.logged,
          profile: payload.user
        });
      }
    case _types.LOGOUT:
      {
        return _extends({}, state, {
          loggedIn: false,
          profile: null
        });
      }
    case _types.BRAND:
      {
        return _extends({}, state, {
          brand: _extends({}, state.brand, payload)
        });
      }
    case _types.TOGGLE_DROPDOWN:
      {
        return _extends({}, state, {
          heimdall: _extends({}, state.heimdall, {
            dropdown: _extends({}, state.heimdall.dropdown, _defineProperty({}, payload, !state.heimdall.dropdown[payload]))
          })
        });
      }
    case _types.METRIC:
      {
        return _extends({}, state, {
          metric: payload.metric
        });
      }
  }
  return state;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/reducer.js
// module id = 100
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38